import { NeighborhoodServiceAreaInfo } from 'rwl-shared/dist/models';
import React from 'react';
import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/pro-solid-svg-icons';
import { ButtonBase } from 'rwl-ui';
import { When } from 'react-if';
import { useGlobal } from '../../../hooks';
import { getIcon } from '../../../utils/mapUtils';

const Container = styled.div`
    min-width: 197px;
    height: 100%;
    border-radius: 8px;
    display: inline-flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    cursor: pointer;
`;

const Content = styled.div`
    width: 100%;
    padding: calc(var(--rwl-spacing-sm) * 1.5);
    background: white;
    box-shadow: 0px 1px 18px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

const TopSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

const TitleSection = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2px;
`;

const ZipCode = styled.div`
    color: rgba(0, 0, 0, 0.87);
    line-height: 28px;
    margin: 0;
    font-weight: 500;
    font-size: 16px;
`;

const City = styled.div`
    position: relative;
    margin-bottom: 0px;
    height: 100%;
    background-color: 'white';
    color: rgba(0, 0, 0, 0.6);
    margin-top: -4px;
    font-weight: 500;
    font-size: 12px;
`;

const StatsRow = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

const StatItem = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
`;

const StatTextGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 3px;
`;

const StatText = styled.p`
    margin: 0;
    font-weight: 500;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.87);
`;

const ButtonContainer = styled.div`
    width: 100%;
    display: flex;
`;

const Spacer = styled.div`
    width: 40px;
    height: 21px;
`;

type SingleZipPopoverProps = {
    serviceArea: NeighborhoodServiceAreaInfo;
    onClick?: () => void;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
};

const SingleZipPopover: React.FC<SingleZipPopoverProps> = ({
    serviceArea: {
        postcode,
        neighborhood,
        jobCount,
        reviewCount,
        averageRating,
    },
    onClick,
    onMouseEnter,
    onMouseLeave,
}) => {
    const { config } = useGlobal();
    const icon = config?.account.mapSettings.icon;
    const iconTint = config?.account.mapSettings.color;

    return (
        <Container
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
        >
            <Content>
                <TopSection>
                    <TitleSection>
                        <ZipCode>{postcode}</ZipCode>
                        <City>{neighborhood}</City>
                    </TitleSection>
                    <StatsRow>
                        <StatItem>
                            <FontAwesomeIcon
                                icon={getIcon(icon)}
                                color={iconTint}
                                size="xs"
                            />
                            <StatTextGroup>
                                <StatText>{jobCount}</StatText>
                                <StatText>projects</StatText>
                            </StatTextGroup>
                        </StatItem>
                        <When condition={reviewCount > 0}>
                            <StatItem>
                                <FontAwesomeIcon
                                    icon={faStar}
                                    color="#FFB400"
                                    size="lg"
                                />
                                <StatText>
                                    {averageRating?.toFixed(1)} ({reviewCount})
                                </StatText>
                            </StatItem>
                        </When>
                    </StatsRow>
                </TopSection>
                <ButtonContainer>
                    <ButtonBase
                        className={'SeeProjectsButton'}
                        onClick={onClick}
                        style={{
                            borderRadius: 'var(--rwl-radius-lg)',
                            backgroundColor: '#00000014',
                            color: 'var(--rwl-text-default)',
                            width: '100%',
                            height: '28px',
                            fontSize: '12px',
                            fontWeight: '500',
                            lineHeight: '20px',
                            wordWrap: 'break-word',
                        }}
                    >
                        See projects
                    </ButtonBase>
                </ButtonContainer>
            </Content>
            <Spacer />
        </Container>
    );
};

export default SingleZipPopover;
